import { createUseStyles } from 'react-jss'

import { transitionShort } from '../../../styles/const/common'
import { darkGrey, lightGrey, trafficRedDark } from '../../../styles/const/colors'
import { input } from '../../../styles/mixins/common'

const symbolWidth = 12 //px
const symbolPadding = 8 //px
const inputPaddingLeft = 13 //px

const getPaddingLeft = ({ hasSymbol, symbolLength, symbolPosition }) => {
  return hasSymbol && symbolPosition !== 'end' ? symbolLength * symbolWidth + inputPaddingLeft : inputPaddingLeft
}
const getPaddingRight = ({ hasSymbol, symbolLength, symbolPosition }) => {
  return hasSymbol && symbolPosition === 'end' ? symbolLength * symbolWidth + symbolPadding : 10
}

const useStyles = createUseStyles(theme => ({
  symbol: ({ symbolPosition, showSymbol, hasValue }) => ({
    opacity: showSymbol || hasValue ? 1 : 0,
    position: 'absolute',
    right: symbolPosition === 'end' ? `${symbolPadding}px` : 'unset',
    left: symbolPosition === 'end' ? 'unset' : `${inputPaddingLeft}px`,
    top: '50%',
    transform: 'translateY(-50%)',
    transition: transitionShort,
    color: darkGrey
  }),
  input: {
    extend: input(theme),
    paddingLeft: props => getPaddingLeft(props),
    paddingRight: props => getPaddingRight(props),
    borderColor: props => (props.showError ? [trafficRedDark, '!important'] : lightGrey)
  }
}))

export default useStyles
